package com.downdogapp.client.widget

import com.downdogapp.*
import com.downdogapp.Overflow.AUTO
import com.downdogapp.Size.Companion.percent
import com.downdogapp.Size.Companion.px
import com.downdogapp.Size.Pixels
import kotlinx.dom.clear
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.HTMLElement

class TableView(parent: HTMLElement, private val getContents: () -> TableContents, maskBottomGradient: Boolean) {

  private var contents = getContents()

  var root: HTMLDivElement = parent.div {
    width = percent(100)
    overflowY = AUTO
  }

  init {
    if (maskBottomGradient) {
      bottomTransparentGradient()
    }
    refreshContents()
  }

  fun refreshContents() {
    contents = getContents()
    root.clear()

    contents.rows.forEachIndexed { index, rowInit ->
      val rowSeparator =
        if (index + 1 < contents.rows.size && rowInit.allowSeparator && contents.rows[index + 1].allowSeparator)
          contents.separator
        else
          null

      rowInit.addToParent(root, rowSeparator)
    }
  }

  private fun bottomTransparentGradient() {
    root.paddingBottom = px(40)
    root.mask = CSSImage.linearGradient(
      listOf(
        CSSImage.Gradient.linearColorStop(Color.BLACK, percent(85)),
        CSSImage.Gradient.linearColorStop(Color.TRANSPARENT)
      )
    )
  }
}

fun HTMLElement.tableView(getContents: () -> TableContents,
                          maskBottomGradient: Boolean = false,
                          block: HTMLDivElement.() -> Unit = {}) =
  TableView(this, getContents, maskBottomGradient).apply { root.block() }

class TableContents(val rows: List<TableRowInit>, val separator: TableSeparator? = null)

class TableSeparator(val height: Pixels = px(1),
                     val color: Color = Color.grey(0.4),
                     val marginLeft: Size,
                     val marginRight: Size)

val fullWidthSeparator =
  TableSeparator(
    marginLeft = HORIZONTAL_CONTENT_GUTTER_PX - px(5),
    marginRight = HORIZONTAL_CONTENT_GUTTER_PX - px(5)
  )

val rightSeparator =
  TableSeparator(
    marginLeft = HORIZONTAL_CONTENT_GUTTER_PX + px(50),
    marginRight = HORIZONTAL_CONTENT_GUTTER_PX - px(5)
  )
